export default "__VITE_ASSET__MR3TMY4B__"